// src/pages/gt3x/Register.jsx
import { useState } from "react";
const debug = window.location.search.includes("debug=1");

// ❗ HIER deine Apps-Script Web-App URL eintragen (exec-URL)
const SCRIPT_URL =
    "https://script.google.com/macros/s/AKfycbyw60Gs6dr5ZLJfrVU3P9CRBzbRYvuAv8JeegB7OJjCoKUYHdODXY5U2sZjuHVzZrnuvQ/exec";

const initialForm = {
    fullName: "",
    iracingName: "",  // neu
    iracingId: "",
    teamName: "",
    numberPro: "",
    numberInt: "",
    numberAm: "",
    // car: "",        // raus
};

export default function RegisterForm() {
    const [form, setForm] = useState(initialForm);
    const filledClass = (value) =>
        value && String(value).trim() !== "" ? " reg-input--filled" : "";
    const [loading, setLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setSuccessMsg("");
        setErrorMsg("");

        try {
            // 👉 FormData statt JSON – vermeidet Preflight/CORS-Ärger
            const fd = new FormData();
            Object.entries(form).forEach(([key, value]) => {
                fd.append(key, value);
            });

            const res = await fetch(SCRIPT_URL, {
                method: "POST",
                body: fd,
                // KEINE headers: { "Content-Type": "application/json" }
                // -> Browser setzt multipart/form-data selbst, bleibt "simple request"
            });

            // Wenn CORS greift, kann die Response evtl. "opaque" sein
            // Dann sehen wir keinen Body, aber Request ist trotzdem raus.
            if (res.type === "opaque") {
                console.warn("Opaque response (CORS) – nehme Erfolg an.");
                setSuccessMsg(
                    "Hiermit wird deine Anmeldung bestätigt. Vielen Dank – wir prüfen deine Daten und melden uns bei dir!"
                );
                setForm(initialForm);
                setLoading(false);
                return;
            }

            const text = await res.text();
            console.log("Apps Script response raw:", text);

            let json;
            try {
                json = JSON.parse(text);
            } catch {
                throw new Error("Konnte Antwort vom Script nicht als JSON lesen.");
            }

            if (!res.ok || !json.ok) {
                throw new Error(json.error || "Unbekannter Fehler vom Apps Script.");
            }

            setSuccessMsg(
                "Hiermit wird deine Anmeldung bestätigt. Vielen Dank!"
            );
            setForm(initialForm);
        } catch (err) {
            console.error("Fehler bei Anmeldung:", err);
            setErrorMsg(
                "Die Anmeldung konnte nicht gespeichert werden. Bitte probiere es später erneut oder kontaktiere die Orga."
            );
        } finally {
            setLoading(false);
        }
    };

    const labelStyle = {
        alignSelf: "center",
        justifySelf: "flex-end",
        marginRight: "8px",
        fontWeight: 600,
        fontFamily:
            'var(--ff-Kallisto), "Rajdhani", system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial',
        fontSize: "0.95rem",
    };

    const fullRow = { gridColumn: "1 / -1" };

    return (
        <div className="card card--accent">
            <h1>GT3 Xperience – Anmeldung</h1>
            <p style={{ marginBottom: "18px",
                fontFamily: 'var(--ff-Everett), sans-serif',
            }}>
                Bitte fülle alle Felder sorgfältig aus. Deine Anmeldung wird direkt in
                unserer Anmeldeliste eingetragen und du kannst im Reiter "Anmeldeliste" deinen Eintrag anschließend sehen. <br/>
                Bitte beachte vor allem den korrekten Iracing Namen einzugeben, damit unsere Automatisierungen im Liga Manager einwandfrei funktionieren <br/>
            </p>

            {debug && (
                <pre style={{
                    fontSize:"12px",
                    padding:"10px",
                    background:"rgba(0,0,0,0.4)",
                    border:"1px solid #444",
                    marginBottom:"14px",
                    color:"#e4fe3c",
                    whiteSpace:"pre-wrap"
                }}>
                    DEBUG MODE AKTIV<br/>
                    Script URL: {SCRIPT_URL}
                                {"\n"}Aktueller Form-State: {JSON.stringify(form, null, 2)}
                </pre>
            )}

            {/* Status-Meldungen */}
            {successMsg && (
                <div
                    style={{
                        marginBottom: "12px",
                        padding: "10px 12px",
                        borderRadius: "8px",
                        border: "1px solid rgba(105,251,144,0.6)",
                        background: "rgba(105,251,144,0.08)",
                        color: "#69fb90",
                        fontSize: "0.96rem",
                    }}
                >
                    {successMsg}
                </div>
            )}
            {successMsg && (
                <div
                    className="card"
                    style={{
                        marginTop: "16px",
                        padding: "22px",
                        lineHeight: "1.55",
                        background: "rgba(255,255,255,0.04)",
                        border: "1px solid rgba(255,255,255,0.1)",
                        borderRadius: "14px",
                    }}
                >
                    <h2 style={{ marginBottom: "12px" }}>Nächste Schritte</h2>

                    <ul style={{ paddingLeft: "22px", margin: 0, fontFamily: 'var(--ff-Everett), var(--ff-Kallisto), sans-serif',
                        fontSize: "0.90rem", fontWeight: "normal",
                        letterSpacing: ".02em", }}>
                        <li>Bitte überprüfe, ob du unserem Discord-Server bereits beigetreten bist.</li>
                        <li>Die Startgebühr beträgt 10€. Bezahlbar via Paypal: race@racevision.info (über die Family & Friends Funktion)</li>
                        <li>Zur Vorbereitung kannst du das Regelwerk vollständig durchlesen.</li>
                        <li>
                            Wenn du dich <strong>vor der Saison</strong> anmeldest:
                            Quali-Events, Ablauf und Server-Infos findest du im Bereich <em>GT3X → Overview</em>.
                        </li>
                        <li>
                            Wenn du dich <strong>während der Saison</strong> anmeldest:
                            Wir tragen dich zeitnah in die Teilnehmerliste ein und ordnen dich PRO oder AM zu.
                        </li>

                    </ul>
                </div>
            )}

            {errorMsg && (
                <div
                    style={{
                        marginBottom: "12px",
                        padding: "10px 12px",
                        borderRadius: "8px",
                        border: "1px solid rgba(255,44,70,0.6)",
                        background: "rgba(255,44,70,0.08)",
                        color: "#ff8c8c",
                        fontSize: "0.96rem",
                    }}
                >
                    {errorMsg}
                </div>
            )}

            {/* 2-Spalten-Formular: links Label, rechts Input */}
            <form
                onSubmit={handleSubmit}
                style={{
                    marginTop: "16px",
                    display: "grid",
                    gridTemplateColumns: "max(160px, 30%) minmax(0, 1fr)",
                    columnGap: "18px",
                    rowGap: "10px",
                    maxWidth: "780px",

                    // MOBILE FIX
                    width:"100%",
                }}
                className="reg-grid"
            >

            <label htmlFor="fullName" style={labelStyle}>
                    Vor- und Nachname
                </label>
                <input
                    id="fullName"
                    placeholder=" "
                    className={`reg-input${filledClass(form.fullName)}`}
                    type="text"
                    name="fullName"
                    value={form.fullName}
                    onChange={handleChange}
                    required
                />

                <label htmlFor="iracingName" style={labelStyle}>
                    exakter iRacing Name
                </label>
                <input
                    id="iracingName"
                    className={`reg-input${filledClass(form.iracingName)}`}
                    type="text"
                    name="iracingName"
                    value={form.iracingName}
                    onChange={handleChange}
                    placeholder="Max Mustermann2"
                    required
                />

                <label htmlFor="iracingId" style={labelStyle}>
                    iRacing ID
                </label>
                <input
                    id="iracingId"
                    placeholder=" "
                    className={`reg-input${filledClass(form.iracingId)}`}
                    type="text"
                    name="iracingId"
                    value={form.iracingId}
                    onChange={handleChange}
                    required
                />

                <label htmlFor="teamName" style={labelStyle}>
                    Teamname
                </label>
                <input
                    id="teamName"
                    placeholder=" "
                    className={`reg-input${filledClass(form.teamName)}`}
                    type="text"
                    name="teamName"
                    value={form.teamName}
                    onChange={handleChange}
                />

                <label htmlFor="numberPro" style={labelStyle}>
                    Startnummer PRO
                </label>
                <input
                    id="numberPro"
                    placeholder="2-99"
                    className={`reg-input${filledClass(form.numberPro)}`}
                    type="text"
                    name="numberPro"
                    value={form.numberPro}
                    onChange={handleChange}
                />
                <label htmlFor="numberAm" style={labelStyle}>
                    Startnummer INT
                </label>
                <input
                    id="numberInt"
                    placeholder="100-499"
                    className={`reg-input${filledClass(form.numberInt)}`}
                    type="text"
                    name="numberInt"
                    value={form.numberInt}
                    onChange={handleChange}
                />

                <label htmlFor="numberAm" style={labelStyle}>
                    Startnummer AM
                </label>
                <input
                    id="numberAm"
                    placeholder="500-999"
                    className={`reg-input${filledClass(form.numberAm)}`}
                    type="text"
                    name="numberAm"
                    value={form.numberAm}
                    onChange={handleChange}
                />

                {/* Button-Zeile */}
                <div
                    style={{
                        ...fullRow,
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "6px",
                    }}
                >
                    <button
                        className="button button--primary"
                        type="submit"
                        disabled={loading}
                        style={{
                            minWidth: "180px",
                            padding: "10px 18px",
                            fontFamily:
                                'var(--ff-Kallisto), "Rajdhani", system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial',
                            fontWeight: 700,
                            letterSpacing: ".04em",
                            textTransform: "uppercase",
                            fontSize: "0.9rem",
                        }}
                    >
                        {loading ? "Sende Anmeldung…" : "Anmelden"}
                    </button>
                </div>
            </form>
        </div>
    );
}
